import { render } from "./home.vue?vue&type=template&id=46c09f70&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=46c09f70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46c09f70"

export default script